import moment from "moment-timezone";

moment.tz.link([
  "America/New_York|Eastern Time (US & Canada)",
  "America/Chicago|Central Time (US & Canada)",
  "America/Boise|Mountain Time (US & Canada)",
  "America/Los_Angeles|Pacific Time (US & Canada)",
  "US/Arizona|Arizona"
]);
